import React from 'react';
import { Card as RadixCard } from '@radix-ui/themes';

const Card = ({ children, className = '', hover = false, onClick }) => {
  return (
    <RadixCard
      onClick={onClick}
      className={className}
      style={hover ? { cursor: 'pointer', transition: 'box-shadow 0.2s ease' } : undefined}
    >
      {children}
    </RadixCard>
  );
};

export default Card;
